import { render } from "./WatchLive.vue?vue&type=template&id=1a4bb6fb&scoped=true&ts=true"
import script from "./WatchLive.vue?vue&type=script&lang=ts"
export * from "./WatchLive.vue?vue&type=script&lang=ts"

import "./WatchLive.vue?vue&type=style&index=0&id=1a4bb6fb&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4bb6fb"]])

export default __exports__